export default __webpack_public_path__ + "static/media/Banner-Curso-Word-Inicial_V2.a8db0d38.jpg";